// extracted by mini-css-extract-plugin
module.exports = {"SocialBtns":"SocialBtns_SocialBtns__1Vvo0"};